import { connect } from 'react-redux'
import { AllState } from '../../../../../store'
import PageHeader, {
  HeaderContent,
  HeaderDivider,
  HeaderGroup,
  IconGroup,
} from '../../../../components/headers/HeaderBar/PageHeader'
import { DateTerm } from '../../../../../utils/date'
import SettingSpeedDial from '../../../../components/headers/HeaderBar/SettingSpeedDial'
import { ToolbarToggleValue } from '../../../../components/toolbars/Toolbar/ToolbarToggle'
import { MonthRangeSelector } from '../MonthRangeSelector'
import UserShiftButtonGroup, {
  UserShiftButtonGroupProps,
} from '../../../ActualWorkingHoursConfirm/components/Header/UserShiftButtonGroup'
import { intl } from '../../../../../i18n'
import { styled } from '@mui/material/styles'
import SplitButton, {
  SplitButtonProps,
} from '../../../../components/buttons/SplitButton'
import ReloadButton from '../../../../containers/BulkSheetView/components/header/ReloadButton'
import FormatListBulletedRounded from '@mui/icons-material/FormatListBulletedRounded'
import { ActiveHeaderIconButton } from '../../../ProjectVersionReport/components/header/common'
import { colorPalette } from '../../../../style/colorPalette'
import { UseFilterPanelReturnValue } from '../../hooks/useFilterPanel'

interface OwnProps {
  loading: boolean
  onSubmit: () => void
  onCancel: () => void
  dateTerm: DateTerm
  onSearch: (dateTerm: DateTerm) => void
  onClickExport: () => void
  toolbar: ToolbarToggleValue | undefined
  onChangeToolbar: (value: ToolbarToggleValue | undefined) => void
  rowHeight: number
  onChangeRowHeight: (value: number) => void
  splitButtonProps: SplitButtonProps
  filterPanel: UseFilterPanelReturnValue
}

interface StateProps {
  notEdited: boolean
}

const TotalSpan = styled('span')({
  whiteSpace: 'nowrap',
})

const StyledIcon = styled(FormatListBulletedRounded)<{ isOpen: boolean }>(
  ({ theme, isOpen }) => ({
    color: isOpen ? colorPalette.monotone[0] : colorPalette.monotone[4],
    transition: theme.transitions.create('color', {
      duration: theme.transitions.duration.short,
    }),
  })
)

type Props = OwnProps & StateProps & UserShiftButtonGroupProps

const TaskActualWorkApproveHeader = (props: Props) => {
  return (
    <PageHeader>
      <HeaderContent>
        <HeaderGroup>
          <ActiveHeaderIconButton
            active={props.filterPanel.isOpen}
            onClick={props.filterPanel.toggle}
          >
            <StyledIcon isOpen={props.filterPanel.isOpen} />
          </ActiveHeaderIconButton>
        </HeaderGroup>
        <HeaderGroup>
          <ReloadButton onReload={props.onCancel} />
        </HeaderGroup>
        <HeaderGroup>
          <MonthRangeSelector
            dateTerm={props.dateTerm}
            onSearch={props.onSearch}
          />
        </HeaderGroup>
        <HeaderGroup>
          <UserShiftButtonGroup
            userName={props.userName}
            currentIndex={props.currentIndex}
            totalCount={props.totalCount}
            onPagingUser={props.onPagingUser}
          />
        </HeaderGroup>
        <HeaderGroup>
          <TotalSpan>
            {intl.formatMessage(
              { id: 'search.hitsTotal' },
              { hit: props.currentIndex, total: props.totalCount }
            )}
          </TotalSpan>
        </HeaderGroup>
        <HeaderDivider />
        <HeaderGroup>
          <IconGroup>
            <SettingSpeedDial
              onClickExport={props.onClickExport}
              rowHeight={props.rowHeight}
              onClickChangeRowHeight={props.onChangeRowHeight}
            />
          </IconGroup>
        </HeaderGroup>
        <HeaderDivider />
        <SplitButton
          options={props.splitButtonProps.options}
          disabled={props.splitButtonProps.disabled}
          buttonStyle={{ height: '28px' }}
        ></SplitButton>
      </HeaderContent>
    </PageHeader>
  )
}

const mapStateToProps = (state: AllState) => ({
  notEdited: !state.hasRequiredSaveData.hasRequiredSaveData,
})

export default connect(mapStateToProps)(TaskActualWorkApproveHeader)
